<template>
  <div
    :key="uniqueKey" class="rich-wrapper"
    :style="{
      width: config.chartWidth +'px',
      height: config.chartHeight +'px',
      fontSize: '22px',
    }">
    <div ref="editable">
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShowRich',
  components: {
  },
  props: {
    config: {
      type: Object,
    },
    globalConfig: {
      type: Object,
    },
    componentType: {
      type: String,
    },
  },
  data () {
    return {
      uniqueKey: 'xxx',
    }
  },
  computed: {
  },
  created () {
    this.uniqueKey = Math.random()
  },
  mounted () {
    this.$refs.editable.innerHTML = this.config.chartViewData.chartData
  },
  methods: {
  },
}
</script>

<style lang='scss' scoped>
.rich-wrapper {
  color: #fff;
  overflow: hidden ;
  padding: 5px;
}
</style>
